import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom'
import AccomodationPage from './pages/AccomodationPage';
import Accomodations from './pages/Accomodations';
import Dashboard from './components/dashboard/Dashboard';
import Signup from './components/signup/Signup';
import Login from './components/login/Login';
import BookingCard from './components/bookingcard/BookingCard';
import Popup from './components/popup/popup';




const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Accomodations />}>
        </Route>
        <Route path='accomodation/:name' element={<AccomodationPage />}></Route>
        <Route path='signin' element={<Login />}></Route>
        <Route path='pop' element={<Popup />}></Route>
        <Route path='book' element={<BookingCard theme='black' />}></Route>
        <Route path='*' element={<p className='h-screen grid place-content-center'>Page Not Found.</p>}></Route>
        <Route path='dashboard' element={<Dashboard />}></Route>
        <Route path='signup' element={<Signup />}> </Route>
        <Route path='login' element={<Login />}></Route>
    </Routes>
    </BrowserRouter >
  );
}

export default App;